import axiosClient from "api/axios_client.js";

export const forgotPasswordRequestApi = async (payload) => {
  const res = await axiosClient.post("/user/get-reset-otp", payload);
  return res.data;
};

export const forgotPasswordVerifyApi = async (payload) => {
  const res = await axiosClient.post("/user/get-login-token", payload);
  return res.data;
};

export const forgotPasswordResetApi = async (payload) => {
  const res = await axiosClient.post("/user/reset-password", payload);
  return res.data;
};
